import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
interface clockInType {
  clockOut_time: string;
  clockOutLoader: boolean;
}

// Define the initial state using that type
const initialState: clockInType = {
  clockOut_time: "",
  clockOutLoader: false,
};

const clockOutSlice = createSlice({
  name: "clockOut",

  initialState,
  reducers: {
    clockOutReducer: (state: any, action: PayloadAction<clockInType>) => {
      const payload = action.payload;
      state.clockOut_time = payload;
    },
    clockOutLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.clockOutLoader = payload;
    },
    resetClockOut: (state: any) => {
      state.clockOut_time = "";
    },
  },
});

export const { clockOutReducer, resetClockOut, clockOutLoader } =
  clockOutSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default clockOutSlice.reducer;
